import { Box, Container } from '@mui/material'
import { useEffect } from 'react'
import { BrowserRouter } from 'react-router-dom'
import { Messages } from './components/Messages'
import { EnionMenu } from './Menu'
import { useApp } from './hooks/useApp'
import { useSocket } from './hooks/useSocket'
import { Topic } from './types/messaging'
import { Copyright } from './components/atoms/Copyright'
import { useDevices } from './hooks/useDevices'
import Initializer from './components/Initializer'
import { AppRoutes } from './AppRoutes'

window.DEBUG = !!DEBUG

function App() {

  useEffect(() => {
    if (window.location.pathname === '/') {
      window.location.replace('/app')
    }
  }, [])

  const app = useApp()
  const { onMessage } = useDevices()

  useSocket('web:global:0' as Topic, onMessage)
  useSocket(`web:user:${app.user ? app.user.id : 0}` as Topic, onMessage)

  return (
    <BrowserRouter basename="app">
      <Container component="main" maxWidth="sm">
        <Box sx={{ minHeight: '100vh', display: 'flex', flexDirection: 'column' }}>
          <EnionMenu/>
          <Messages/>
          <Initializer/>
          <Box sx={{ flexGrow: 1 }}>
            <AppRoutes/>
          </Box>
          <Copyright/>
        </Box>
      </Container>
    </BrowserRouter>
  )
}

export default App
